@if (!loadComplete()) {
  <is-wait-message [loadComplete]="loadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0"></is-wait-message>
} @else {
  <form (ngSubmit)="submit()" [formGroup]="paymentFormGroup.group" class="manage-payment-form-container">
    <div class="bolt-container">
      <bolt-progress-bar-bar appFocusOnInit arialabel="setup automatic payments progress value is 20%" class="progress-bar-container to-container" value="20"></bolt-progress-bar-bar>
      <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Set up automatic payments</h1>

      <div class="bolt-row">
        <div class="bolt-col-12">
          @if (selectedPaymentMethod?.isBankCard) {
            <bolt-notification type="info" class="bolt-space-bottom-2xl to-container">
              <is-interpolate [text]="bankCardAutomaticPaymentsCapMessage"></is-interpolate>
            </bolt-notification>
          }

          @if (globalErrorDisplayable && !accountValidationMessage) {
            <bolt-notification type="error" [id]="'global-error-message'" class="bolt-space-bottom-2xl to-container">Please check the information below and try again.</bolt-notification>
          }

          @if (displayVulCreditCardErrorMessage) {
            <bolt-notification type="error" id="vulCreditCardErrorMessage" class="bolt-space-bottom-2xl to-container">
              {{ vulCreditCardErrorMessage() }}
            </bolt-notification>
          }

          <section id="payment-method-section" class="fluid-container">
            <app-payment-sub-header>Payment information</app-payment-sub-header>
            @if (accountValidationMessage) {
              <bolt-notification type="error" id="accountValidationerrorMessageId" class="bolt-space-bottom-2xl to-container">
                {{ accountValidationMessage }}
              </bolt-notification>
            }
            <div class="section-content">
              <div
                [ngClass]="
                  (selectedPaymentMethod?.isBankAccount && !selectedPaymentMethod.isNewMethod && (updatePaymentMethodOnFile || !selectedPaymentMethod.isDefault)) ||
                  selectedPaymentMethod?.isBankCard ||
                  (selectedPaymentMethod?.isBankAccount && selectedPaymentMethod.isNewMethod)
                    ? ''
                    : 'bolt-space-bottom-lg'
                ">
                <app-payment-method-section
                  [hasDefaultMethod]="hasDefaultMethod(paymentMethods)"
                  [hasSavedPaymentMethod]="hasSavedPaymentMethod(paymentMethods)"
                  [(selectedPaymentMethod)]="selectedPaymentMethod"></app-payment-method-section>
              </div>
            </div>
          </section>

          <app-consider-this formGroupName="considerThisGroup" [isEligibleForEasyPay]="isEasyPayEligible" [isAutoPayment]="isAutoPayment"></app-consider-this>
        </div>
      </div>
    </div>
    <bolt-notification type="info" class="bolt-space-bottom-2xl to-container bottom-info">
      If there is a change in your premium amount you'll receive a notification before any automatic payment is processed.
    </bolt-notification>
    <bolt-button-bar>
      <bolt-button slot="cancel" id="cancel-button" (click)="cancelSetupAutomaticPayments()">Cancel</bolt-button>
      <bolt-button submit slot="forward" type="solid" id="continue-button" [disabled]="showEFTAuthFormValidationMessage && chosenPaymentMethod?.isBankAccount">Continue</bolt-button>
    </bolt-button-bar>
  </form>
}
